import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  skills: []
}

const getters = {
  skills: state => state.skills
}

const mutations = {
  skills: (state, skills) => {
    state.skills = skills
  }
}

const actions = {
  async fetchSkills ({ commit }) {
    const response = await axios.get(`${config.getRootApi()}/skills`)
    commit('skills', response.data)
  },
  async createSkill ({ commit, state }, name) {
    const response = await axios.post(`${config.getRootApi()}/skills`, { name: name })
    if (response.status === 201) {
      const newSkill = response.data
      commit('skills', [...state.skills, newSkill])
      return newSkill
    } else {
      console.error('Could not create skill')
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
